import React from 'react';
import {
    Select,
    makeStyles,
    Theme,
    createStyles,
    FormControl,
    InputLabel,
    Input,
    Chip,
    MenuItem,
    useTheme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            maxWidth: 250,
        },
        input: {},
    })
);

function getStyles(name: string, personName: string[], theme: Theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}
interface Props {
    onMultiSelectChange: (values: string[]) => void;
    values: string[];
    label: string;
    options: string[];
    disabled?: boolean;
}

const MultiSelect: React.FC<Props> = ({
    onMultiSelectChange,
    values,
    label,
    options,
    disabled = false,
}) => {
    const classes = useStyles();
    const theme = useTheme();
    console.log('options in MultiSelect', options);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        onMultiSelectChange(event.target.value as string[]);
    };

    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="mutiple-chip-label">{label}</InputLabel>
            <Select
                labelId="mutiple-chip-label"
                multiple
                value={values}
                onChange={handleChange}
                input={
                    <Input disabled={disabled} /* variant="outlined" */ id="select-multiple-chip" />
                }
                renderValue={selected => (
                    <div className={classes.chips}>
                        {(selected as string[]).map(value => (
                            <Chip key={value} label={value} className={classes.chip} />
                        ))}
                    </div>
                )}
                // MenuProps={MenuProps}
            >
                {options.map(option => (
                    <MenuItem key={option} value={option} style={getStyles(option, values, theme)}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MultiSelect;
